import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { DocumentStatisticsService } from 'src/app/services/core/document-statistics/document-statistics.service';
@UntilDestroy()
@Component({
  selector: 'app-documents-statistics',
  templateUrl: './documents-statistics.component.html',
  styleUrls: ['./documents-statistics.component.css']
})
export class DocumentsStatisticsComponent implements OnInit {

  documentStats: any
  companyStats:any = [];
  companies: any;
  selectedCompany: any = '';
  windowDaysOptions = [15, 30, 90];
  windowDays = 15;
  expiredDocsModalObj: any = null;

  readonly DEFAULT_CARDS_PANEL_HEIGHT = 340;
  cardsPanelHeight = this.DEFAULT_CARDS_PANEL_HEIGHT;
  private readonly MIN_CARDS_PANEL_HEIGHT = 60;
  private readonly MAX_CARDS_PANEL_HEIGHT = 700;
  private resizeStartY = 0;
  private resizeStartHeight = 0;

  constructor(
    private documentStatisticsService: DocumentStatisticsService,
    private credentialService: CredentialService,
  ) { }

  ngOnInit(): void {
    this.getCompanies();
    this.getOverview();
    this.getDocumentStatistics();
  }

  private buildQueryParams() {
    const queryParams: any = {
      windowDays: this.windowDays,
      company: this.selectedCompany,
    }
    if (!this.selectedCompany) {
      delete queryParams.company;
    }
    return queryParams;
  }

  getOverview() {
    this.documentStatisticsService.getOverview(this.buildQueryParams()).subscribe((data: any) => {
      this.documentStats = data;
    })
  }

  getDocumentStatistics() {
    this.documentStatisticsService.getCompanyWiseStats(this.buildQueryParams()).subscribe((data: any) => {
      this.companyStats = data;
    })
  }

  getCompanies() {
    const queryparams = {
      limit: 9999,
      isActive: true,
    }
    this.credentialService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.companies = data.results;
        }
      })
  }

  onCompanyChange() {
    this.getOverview();
    this.getDocumentStatistics();
  }

  onWindowDaysChange() {
    this.getOverview();
    this.getDocumentStatistics();
  }

  openExpiredDocsModal(companyId: any, entityType: string, documentType: string, status: 'expired' | 'willExpire', count: number) {
    if (!count) {
      return;
    }
    const resolvedCompanyId = companyId || this.selectedCompany;
    const companyName = this.companies?.find((company: any) => company.id === resolvedCompanyId)?.name || '';
    this.expiredDocsModalObj = {
      companyId: resolvedCompanyId,
      companyName,
      entityType,
      documentType,
      status,
      windowDays: this.windowDays,
    };
  }

  onCloseExpiredDocsModal() {
    this.expiredDocsModalObj = null;
  }

  startResize(event: MouseEvent) {
    this.resizeStartY = event.clientY;
    this.resizeStartHeight = this.cardsPanelHeight;
    event.preventDefault();
    document.addEventListener('mousemove', this.onResizeMove);
    document.addEventListener('mouseup', this.stopResize);
  }

  private onResizeMove = (event: MouseEvent) => {
    const delta = event.clientY - this.resizeStartY;
    this.cardsPanelHeight = Math.min(
      this.MAX_CARDS_PANEL_HEIGHT,
      Math.max(this.MIN_CARDS_PANEL_HEIGHT, this.resizeStartHeight + delta)
    );
  }

  private stopResize = () => {
    document.removeEventListener('mousemove', this.onResizeMove);
    document.removeEventListener('mouseup', this.stopResize);
  }

  resetCardsPanelHeight() {
    this.cardsPanelHeight = this.DEFAULT_CARDS_PANEL_HEIGHT;
  }

}
